import { Language } from '@pai/commons'

import { LanguageItem } from 'app/core/cms/generated/api-types'

import { AltUrls } from './create-alternate-url.function'
import { hasPropsDefined } from './has-props-defined.function'

export type ExtLangItem = LanguageItem & { altUrl: string; selected: boolean }

export function extendLangItems(
  languageItems: readonly LanguageItem[],
  currentLang: Language,
  altUrls: AltUrls,
): ExtLangItem[] | null {
  const extItems = languageItems
    .filter((item) => hasPropsDefined(item, ['language', 'label', 'abbr']))
    .map((langItem): ExtLangItem & { altUrl?: string } => ({
      ...langItem,
      altUrl: altUrls[<Language>langItem.abbr.toLowerCase()]?.altUrl,
      selected: langItem.language === currentLang,
    }))
    .filter((langItem): langItem is ExtLangItem => langItem.altUrl !== undefined)

  return extItems.length > 1 ? extItems : null
}
